import { render, staticRenderFns } from "./RemoteDialog.vue?vue&type=template&id=ad5d60cc&"
import script from "./RemoteDialog.vue?vue&type=script&lang=js&"
export * from "./RemoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports